import { FastClick } from 'fastclick'

FastClick.prototype.focus = (targetElement: any) => {
  let length
  if (
    targetElement.setSelectionRange &&
    targetElement.type.indexOf("date") !== 0 &&
    targetElement.type !== "time" &&
    targetElement.type !== "month"
  ) {
    length = targetElement.value.length
    targetElement.focus()
    targetElement.setSelectionRange(length, length)
  } else {
    targetElement.focus()
  }
}

if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function () {
    // FastClick.attach(document.body)
    // FastClick.attach(document.getElementsByClassName('van-popup'))
  }, false)
}
